import React from 'react';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { DataRequestAdminHeaderComponent } from './data-request-admin-header.component';
import { DataRequestHeaderComponent } from './data-request-header.component';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { useWatch } from 'react-hook-form';

interface RequestHeaderContainerComponentProps {
    onEditTitleClick?: () => void;
    onSaveClick?: () => void;
    onSubmitClick?: () => void;
}

export const RequestHeaderContainerComponent = ({ onEditTitleClick, onSaveClick, onSubmitClick }: RequestHeaderContainerComponentProps) => {
    const { hasAnyPermission, hasPermission } = useActiveUserContext();
    //TODO PERMFE - redo with permissions+
    const isOrgAdmin = !hasPermission(PermissionsEnum.DrActAdv) && hasAnyPermission([PermissionsEnum.ProviderActAdv]);
    const title = useWatch({ name: 'requestTitle' });

    //For vivli admin users of both Clinical and AMR
    //TODO PERMFE - redo with permissions+
    if (hasPermission(PermissionsEnum.DrActAdv) || isOrgAdmin) {
        return (
            <DataRequestAdminHeaderComponent
                onEditTitleClick={onEditTitleClick}
                onSaveClick={onSaveClick}
                onSubmitClick={onSubmitClick}
                title={title}
                isVivliAdmin={true}
            />
        );
    }

    //For non-admin users of both Clinical and AMR
    return (
        <DataRequestHeaderComponent
            onEditTitleClick={onEditTitleClick}
            onSaveClick={onSaveClick}
            onSubmitClick={onSubmitClick}
            title={title}
        />
    );
};
